module.exports = __webpack_public_path__ + "static/media/documentDownload_v2.7b48c2b5.svg";